export default __webpack_public_path__ + "locales/en/Translations.json?hash=74cef29cdc095a9aa65c29f63feba285";